import { IPersonalInfo } from '../../../types';
export type PersonalInfoState = IPersonalInfo;

export enum PersonalInfoActionTypes {
  UPDATE_PI_FIELD = '@@visa/personalInfo/UPDATE_PI_FIELD',
}

export enum Pages {
  PAGE1 = 'uni-pi-step1',
  PAGE2 = 'uni-pi-step2',
  PAGE3 = 'uni-pi-step3',
  PAGE4 = 'uni-pi-step4',
  PAGE5 = 'uni-pi-step5',
  PAGE5_1 = 'uni-pi-step5_1',
  PAGE6 = 'uni-pi-step6',
  PAGE7 = 'uni-pi-step7',
  PAGE8 = 'uni-pi-step8',
  PAGE9 = 'uni-pi-step9',
  PAGE10 = 'uni-pi-step10',
}
